import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12"></div>
        </div>
        <div className="row bor">
          <div className="col-md-2">
            <h6>About</h6>
            <Link>Contact us</Link>
            <br />
            <Link>About us</Link>
            <br />
            <Link>Career</Link>
            <br />
            <Link>Wholesale</Link>
            <br />
          </div>
          <div className="col-md-2">
            <h6>Help</h6>
            <Link>Payments</Link>
            <br />
            <Link>Shippings</Link>
            <br />
            <Link>FAQ</Link>
            <br />
            <Link>Report Us</Link>
            <br />
          </div>
          <div className="col-md-2">
            <h6>Policys</h6>
            <Link>Return Policy</Link>
            <br />
            <Link>Terms of Use</Link>
            <br />
            <Link>Security</Link>
            <br />
            <Link>Sitemap</Link>
            <br />
          </div>
          <div className="col-md-2">
            <h6>Social</h6>
            <Link>FaceBook</Link>
            <br />
            <Link>Twitter</Link>
            <br />
            <Link>LinkedIn</Link>
            <br />
          </div>
          <div className="col-md-2">
            <h6>Mail Us</h6>
            <h5>
              ShopIn Internet Private Limited, Buildings Alyssa, Begonia & Clove
              Embassy Tech Village, Outer Ring Road, Devarabeesanahalli Village,
              Bengaluru, 560103, Karnataka, India
            </h5>
          </div>
        </div>
        <hr />
        <div className="row ">
          <div className="col-6">
            <h4>Copyrights 2020 @shopin</h4>
          </div>
          <div className="col-6 text-right">
            <h4>
              Developed by{" "}
              <a target="_blank" href="https://babz-balaji.web.app/">
                Babz Balaji
              </a>{" "}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}
